import Table, { ColumnsType } from "antd/es/table";
import { localizeDate, isUserHasRoleTypes } from "../../../utils";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { Button, Popconfirm } from "antd";
import { useAppSelector } from "../../../redux/hooks";

const RefundTable = (props: any) => {
  const { data, title, onUpdatePaymentModal, assignmentId, onDeleteRefund } = props;
  const auth = useAppSelector<any>((store) => store.auth);
  const user = auth.user;

  const isSuperUser = (user: any) => {
    return isUserHasRoleTypes(user, ["super_user"]);
  };

  const columns: ColumnsType<any> = [
    {
      title: "Payment Ref Number",
      dataIndex: "payment_ref_number",
      key: "payment_ref_numbe"
    },
    {
      title: "Payment Date",
      dataIndex: "payment_date",
      key: "payment_date",
      render: (payment_date) => <>{payment_date ? localizeDate(payment_date) : "-"}</>
    },
    {
      title: "Payment Amount",
      dataIndex: "payment_amount",
      key: "payment_amount"
    },
    {
      title: "Payment Party Code",
      dataIndex: "payment_party_code",
      key: "payment_party_code"
    },
    {
      title: "Bank Name",
      dataIndex: "bank_name",
      key: "bank_name"
    },
    {
      title: "Payment Description",
      dataIndex: "payment_description",
      key: "payment_description"
    }
  ];

  const actionColumn = {
    title: "Action",
    key: "action",
    render: (_: any, refundData: any) => (
      <>
        <Button
          icon={<EditOutlined />}
          onClick={() => onUpdatePaymentModal(refundData, "refund")}
          title="Update"
        ></Button>
        <Popconfirm
          title="Are you sure you want to delete refund details"
          okText="Delete"
          placement="bottom"
          cancelText="Cancel"
          onConfirm={(event) => {
            onDeleteRefund(assignmentId, refundData.id);
          }}
          onCancel={(event: any) => event.stopPropagation()}
        >
          <Button icon={<DeleteOutlined />} title="Delete"></Button>
        </Popconfirm>
      </>
    )
  };

  const editActionColumn = {
    title: "Action",
    key: "action",
    render: (_: any, refundData: any) => (
      <Button
        icon={<EditOutlined />}
        onClick={() => onUpdatePaymentModal(refundData, "refund")}
        title="Update"
      ></Button>
    )
  };

  if (isSuperUser(user)) {
    columns.push(actionColumn);
  }

  if (isUserHasRoleTypes(user, ["finance_controller"])) {
    columns.push(editActionColumn);
  }

  return (
    <div style={{ marginTop: 50 }}>
      <h2>{title}</h2>
      <Table
        rowKey="id"
        bordered
        columns={columns}
        pagination={false}
        dataSource={data}
        scroll={{ x: 400 }}
      />
    </div>
  );
};

export default RefundTable;
